import { Navigate, useParams } from "react-router-dom";

// Component to redirect old profile route to new one
const RedirectOldProfileRoute = () => {
    const { userId } = useParams();
    return <Navigate to={`/profile/${userId}`} replace />;
};

export default RedirectOldProfileRoute;
